/** Remove private, tab-local customer drafts when the session ends. */
export function clearCustomerDrafts(options: { preserveGuest?: boolean } = {}) {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (
        key?.startsWith("reviewed.request-draft.") ||
        key?.startsWith("reviewed.message-draft.") ||
        key?.startsWith("reviewed.private-draft.") ||
        key?.startsWith("reviewed.question-draft.") ||
        (key === "reviewed.guest-draft" && !options.preserveGuest)
      )
        sessionStorage.removeItem(key);
    }
  } catch {
    /* Browser storage may be disabled. */
  }
}
